import ActiveFlagDialog from "./ActiveFlagDialog";

export default ActiveFlagDialog;
